import { useContext } from "react";
//import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import Select from "../../Components/Select";
import TextInput from "../../Components/TextInput";
//import TextInput from "../Components/TextInput";
import "./TasinmazBilgileri.css";
//import TextArea from "../../Components/TextArea";
import { Link } from "react-router-dom";

export default function TasinmazBilgileri() {
  const {
    tasinmazIller,
    tasinmazIlceler,
    tasinmazSecilenSehir,
    settasinmazSecilenSehir,
    tasinmazSecilenIlce,
    settasinmazSecilenIlce,
    tasinmazSecilenKoyMahalle,
    settasinmazSecilenKoyMahalle,
    tasinmazKoyMahalle,
    adaNo,
    setAdaNo,
    parselNo,
    setParselNo,
    metreKare,
    setMetreKare,
    mevkii,
    setMevkii,
    tasinmazVasfi,
    setTasinmazVasfi,
    tasinmazVasiflari,
    setKamulasacakMetreKare,
    kamulasacakMetreKare,
    //tasinmazMalikleri,
    //setTasinmazMalikleri,
    //MALİKLERİ LİSTEDEN AL

    malikListesi,
    setMalikListesi,
  } = useContext(GlobalContext);

    const malikListesiDegistir = (e, index) => {
      const { name, value } = e.target;
      const list = [...malikListesi];
      list[index][name] = value;
      setMalikListesi(list);
      console.log(list);
    };

    const malikSil = (index) => {
      const list = [...malikListesi];
      list.splice(index, 1);
      setMalikListesi(list);
    };

    const malikEkle = () => {
      setMalikListesi([
        ...malikListesi,
        { adi: "", pay: "", payda: "" },
      ]);
    };

  return (
    <>
      <div className="container">
        <div className="row text-center my-5">
          <h1>Dava Konusu Taşınmaz Bilgileri</h1>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-3 col-xl-3 col-sm-4 col-md-5">
            <label htmlFor="tasinmazIlSelect">Taşınmazın İli</label>
            <Select
              Change={settasinmazSecilenSehir}
              name="tasinmazIlSelect"
              liste={tasinmazIller}
              mesaj="İl Seçiniz"
              value={tasinmazSecilenSehir}
            />
            <label htmlFor="tasinmazIlceSelect">Taşınmazın İlçesi</label>
            <Select
              Change={settasinmazSecilenIlce}
              name="tasinmazIlceSelect"
              liste={tasinmazIlceler}
              mesaj="İlçe Seçiniz"
              value={tasinmazSecilenIlce}
            />
            <label htmlFor="tasinmazKoySelect">Taşınmazın Köyü/Mahallesi</label>
            <Select
              Change={settasinmazSecilenKoyMahalle}
              name="tasinmazKoySelect"
              liste={tasinmazKoyMahalle}
              mesaj="Köy/Mahalle Seçiniz"
              value={tasinmazSecilenKoyMahalle}
            />
          </div>

          <div className="col-lg-3 col-xl-3 col-sm-7 col-md-5">
            <TextInput
              type="number"
              name="ada"
              detail="Ada"
              Change={setAdaNo}
              value={adaNo}
            />
            <TextInput
              type="number"
              name="parsel"
              detail="Parsel"
              Change={setParselNo}
              value={parselNo}
            />
            <TextInput
              type="number"
              name="metrekare"
              detail="Toplam Alan"
              Change={setMetreKare}
              value={metreKare}
            />
            <div className="row">
              {/* <div className="form-check">
                <input
                  className="form-check-input"
                  onClick={(e) =>
                    metreKare ? setKamulasacakMetreKare(metreKare) : 0
                  }
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Taşınmazın Tamamı Kamulaşacak
                </label>
              </div> */}
              <TextInput
                type="number"
                name="kamulasacakmetrekare"
                detail="Kam. Alanı"
                Change={setKamulasacakMetreKare}
                value={kamulasacakMetreKare}
              />
            </div>

            <TextInput
              type="text"
              name="mevkii"
              detail="Mevkii"
              Change={setMevkii}
              value={mevkii}
            />
            <Select
              Change={setTasinmazVasfi}
              liste={tasinmazVasiflari}
              name="tasinmazVasifSelect"
              mesaj="Taşınmazın Tapudaki Vasfı"
              value={tasinmazVasfi}
            />
          </div>
          <div className="col-lg-6 col-xl-5  mx-5">
            <h3 className="text-danger my-1">
              TAŞINMAZ HİSSEDARLARINI GİRİNİZ
            </h3>
            <div className="row">
              {malikListesi.map((evrak, index) => (
                <div key={index} className="card mb-3 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-center text-success">
                      Hissedar #{index + 1}
                    </h5>
                    <div className="row">
                      <div className="col-5">
                        <label
                          htmlFor={`adi-${index}`}
                          className="form-label"
                          style={{ height: 50 }}
                        >
                          Hissedar Adı
                        </label>
                        <input
                          id={`adi-${index}`}
                          name="adi"
                          type="text"
                          className="form-control"
                          placeholder="Hissedar Adı"
                          value={malikListesi[index].adi || ""}
                          onChange={(e) => malikListesiDegistir(e, index)}
                        />
                      </div>
                      <div className="col-2">
                        <label htmlFor={`pay-${index}`} className="form-label">
                          Hissedar Payı
                        </label>
                        <input
                          id={`pay-${index}`}
                          name="pay"
                          type="number"
                          className="form-control"
                          placeholder="Pay"
                          value={malikListesi[index].pay || ""}
                          onChange={(e) => malikListesiDegistir(e, index)}
                        />
                      </div>
                      <div className="col-2">
                        <label
                          htmlFor={`payda-${index}`}
                          className="form-label"
                        >
                          Hissedar Paydası
                        </label>
                        <input
                          id={`payda-${index}`}
                          name="payda"
                          type="number"
                          className="form-control"
                          placeholder="Payda"
                          value={malikListesi[index].payda || ""}
                          onChange={(e) => malikListesiDegistir(e, index)}
                        />
                      </div>
                      <div className="col-2 d-flex align-items-end">
                        {malikListesi.length !== 1 && (
                          <button
                            type="button"
                            onClick={() => malikSil(index)}
                            className="btn btn-danger w-100"
                          >
                            Sil
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {malikListesi.length < 20 && (
                <button onClick={malikEkle} className="btn btn-primary mt-3">
                  Hissedar Ekle
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-3">
            <Link to="/dosyabilgileri">
              <button className="btn btn-success btn-lg mt-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-left-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                  />
                </svg>{" "}
                Dosya Bilgileri
              </button>
            </Link>
          </div>
          <div className="col-3"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <Link to="/kesifbilgileri">
              <button className="btn btn-primary btn-lg mt-5">
                Keşif Bilgilerine Git
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-right-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                  />
                </svg>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
